import script from "./PromptCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./PromptCard.vue?vue&type=script&setup=true&lang=ts"

import "./PromptCard.vue?vue&type=style&index=0&id=f328976c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f328976c"]])

export default __exports__